import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import MaterialTable from 'material-table'
import Checkbox from '@material-ui/core/Checkbox'
import TablePagination from '@material-ui/core/TablePagination'
import Helper from '../../utils/Helper'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

// The pagination component is not right with rtl
const components = {
  Pagination: (props: any) => (
    <TablePagination {...props} style={{ direction: 'ltr' }} />
  ),
}

const Episodes = () => {
  const [episodes, setEpisodes]: any = useState([])
  const history = useHistory()

  useEffect(() => {
    fetchEpisodes()
  }, [])

  const fetchEpisodes = async () => {
    // TODO: /episodes-visitor
    const data = await Helper.ApiRequest('/episodes')
    const filtered = data.filter((episode) => episode.forVisitor)
    setEpisodes(filtered)
  }

  const pageTitle = 'Visitor Episodes'

  const columns = [
    { title: 'Title', field: 'title' },
    { title: 'Order', field: 'order' },
    { title: 'Chapters', field: 'nbChapters' },
    { title: 'Activities', field: 'nbActivities' },
    {
      title: 'Published',
      field: 'state',
      type: 'boolean',
      render: (rowData) => (
        <Checkbox checked={rowData.state === 'published'} disabled />
      ),
      customFilterAndSearch: (term, rowData) => {
        if (term === 'checked') {
          return rowData.state === 'published'
        } else if (term === 'unchecked') {
          return rowData.state !== 'published'
        }
      },
    },
  ]

  const options = {
    columnsButton: true,
    exportButton: true,
    filtering: true,
    emptyRowsWhenPaging: false,
    pageSize: 10,
    actionsColumnIndex: -1,
  }

  const handleEdit = (e, rowData) => {
    history.push(`/episodes/${rowData.slug}?visitor=true`)
  }

  const actions = [
    {
      icon: 'edit',
      tooltip: 'Edit visitor episode',
      onClick: (e, row) => {
        handleEdit(e, row)
      },
    },
  ]

  return (
    <MaterialTable
      // @ts-expect-error legacy
      columns={columns}
      data={episodes}
      title={pageTitle}
      options={options}
      components={components}
      actions={actions}
    />
  )
}

export default withRouter(Episodes)
